export default __webpack_public_path__ + "static/media/2-min.b382f546.jpg";